export const SET_SELECTED_MERCHANT = "SET_SELECTED_MERCHANT";
